// extracted by mini-css-extract-plugin
export default {"projectsContainer":"index_projectsContainer__o8Ikp","sectionTitle":"index_sectionTitle__Hy+TR"};